(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.DataSourceIds = exportFn();
        });
    }

    function exportFn() {
        return {
            COMPANIES: 'COMPANIES',

            CROSS_CHANNEL_PUBLIC_PRESENCE_DATA: 'CROSS_CHANNEL_PUBLIC_PRESENCE_DATA',
            TWITTER_PUBLIC_PRESENCE_DATA: 'TWITTER_PUBLIC_PRESENCE_DATA',
            FACEBOOK_PUBLIC_PRESENCE_DATA: 'FACEBOOK_PUBLIC_PRESENCE_DATA',
            YOUTUBE_PUBLIC_PRESENCE_DATA: 'YOUTUBE_PUBLIC_PRESENCE_DATA',
            INSTAGRAM_PUBLIC_PRESENCE_DATA: 'INSTAGRAM_PUBLIC_PRESENCE_DATA',
            TIKTOK_PUBLIC_PRESENCE_DATA: 'TIKTOK_PUBLIC_PRESENCE_DATA',

            CROSS_CHANNEL_PUBLIC_POST_DATA: 'CROSS_CHANNEL_PUBLIC_POST_DATA',
            TWITTER_PUBLIC_POST_DATA: 'TWITTER_PUBLIC_POST_DATA',
            FACEBOOK_PUBLIC_POST_DATA: 'FACEBOOK_PUBLIC_POST_DATA',
            INSTAGRAM_PUBLIC_POST_DATA: 'INSTAGRAM_PUBLIC_POST_DATA',
            YOUTUBE_PUBLIC_POST_DATA: 'YOUTUBE_PUBLIC_POST_DATA',
            TIKTOK_PUBLIC_POST_DATA: 'TIKTOK_PUBLIC_POST_DATA',

            TIKTOK_PRIVATE_PRESENCE_DATA: 'TIKTOK_PRIVATE_PRESENCE_DATA',

            LINKEDIN_PRIVATE_POST_DATA: 'LINKEDIN_PRIVATE_POST_DATA',
            INSTAGRAM_PRIVATE_POST_DATA: 'INSTAGRAM_PRIVATE_POST_DATA',
            INSTAGRAM_PRIVATE_STORY_FRAME_DATA: 'INSTAGRAM_PRIVATE_STORY_FRAME_DATA',
            FACEBOOK_PRIVATE_POST_DATA: 'FACEBOOK_PRIVATE_POST_DATA',
            TIKTOK_PRIVATE_POST_DATA: 'TIKTOK_PRIVATE_POST_DATA',

            CROSS_CHANNEL_INSIGHTS_POST_DATA: 'CROSS_CHANNEL_INSIGHTS_POST_DATA',

            LISTENING_QUERY_SEARCH: 'LISTENING_QUERY_SEARCH',
            QUID_TOPICS: 'QUID_TOPICS',
            LISTENING_QUERY_SEARCH_RECOMMENDATIONS: 'LISTENING_QUERY_SEARCH_RECOMMENDATIONS'
        };
    }
})();
